import { getTotalPrice } from 'utils/book-rental-items/rentalTotalPrice';

const getWidgetRentalTotalPrice = (widgetForm, productData) => {


  const {
    currency,
    dates,
    multiDates,
    availableUnits,
    addOns,
    startBookingsDate,
    startTime,
    endTime,
  } = widgetForm.values;

  const total = getTotalPrice(
    productData,        
    startBookingsDate,  
    endTime,          
    startTime,          
    multiDates || dates, 
    availableUnits,    
    addOns,             
    currency        
  );

  return total;
};


export { getWidgetRentalTotalPrice };
